import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { account } from "../../rbac-consts";
import { default as AdminAccountContainer } from "./admin/AccountContainer";
import { default as ClientAccountContainer } from "./client/AccountContainer";
import { default as SupportAccountContainer } from "./support/AccountContainer";

const AccountWrapper = () => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={account.ADMIN}
        yes={() => (
          <AdminAccountContainer />
        )}
      />
      <Can
        role={user.roles}
        perform={account.SUPPORT}
        yes={() => (
          <SupportAccountContainer />
        )}
      />
      <Can
        role={user.roles}
        perform={account.USER}
        yes={() => (
          <ClientAccountContainer />
        )}
      />
    </>
  );
};

export default AccountWrapper;